/**
 * Desktop: Jimmy Fairly–style fullscreen vertical gallery on image click.
 * Mobile pinch zoom stays in product-mobile-media-carousel.js.
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 1100px)');

  let overlay = null;
  let scrollEl = null;
  let closeBtn = null;

  // Fullscreen view uses the largest srcset candidate, not the size picked for the page layout
  const getLargestSrc = (img) => {
    const candidates = (img.getAttribute('srcset') || '').split(',').map((c) => c.trim().split(/\s+/)[0]).filter(Boolean);
    return candidates.length ? candidates[candidates.length - 1] : img.currentSrc || img.src;
  };

  const getImageData = (img) => ({
    src: getLargestSrc(img),
    alt: img.alt || '',
  });

  const collectGalleryImages = (clickedImg) => {
    const metafieldGallery = clickedImg.closest('.product-metafield-gallery');
    if (metafieldGallery) {
      return Array.from(
        metafieldGallery.querySelectorAll('.desktop-images .desktop-image')
      ).map(getImageData);
    }

    const mediaWrapper = clickedImg.closest('.product__media-wrapper');
    if (!mediaWrapper) return [];

    const imgs = mediaWrapper.querySelectorAll(
      '.product__media-list .product__media-item:not(.product__media-item--hidden) img'
    );

    return Array.from(imgs)
      .filter((img) => !img.closest('video, model-viewer, .deferred-media'))
      .map(getImageData);
  };

  const ensureOverlay = () => {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'product-desktop-gallery-fullscreen';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<button type="button" class="product-desktop-gallery-fullscreen__close" aria-label="Close gallery">' +
      '<span aria-hidden="true">&times;</span></button>' +
      '<div class="product-desktop-gallery-fullscreen__scroll"></div>';

    document.body.appendChild(overlay);
    scrollEl = overlay.querySelector('.product-desktop-gallery-fullscreen__scroll');
    closeBtn = overlay.querySelector('.product-desktop-gallery-fullscreen__close');

    closeBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      closeFullscreen();
    });
    overlay.addEventListener('click', () => {
      if (overlay.classList.contains('is-open')) closeFullscreen();
    });
    document.addEventListener('keydown', onKeydown);
  };

  const closeFullscreen = () => {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-desktop-gallery-fullscreen-active');
    document.body.style.overflow = '';
    scrollEl.innerHTML = '';
  };

  const openFullscreen = (clickedImg) => {
    const images = collectGalleryImages(clickedImg);
    if (!images.length) return;

    const clickedSrc = getImageData(clickedImg).src;
    let startIndex = images.findIndex((item) => item.src === clickedSrc);
    if (startIndex < 0) startIndex = 0;

    ensureOverlay();

    scrollEl.innerHTML = images
      .map(
        (item) =>
          '<div class="product-desktop-gallery-fullscreen__item">' +
          '<img src="' +
          item.src +
          '" alt="' +
          item.alt.replace(/"/g, '&quot;') +
          '" loading="eager">' +
          '</div>'
      )
      .join('');

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-desktop-gallery-fullscreen-active');
    document.body.style.overflow = 'hidden';

    const target = scrollEl.children[startIndex];
    if (target) {
      window.requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }
  };

  const onKeydown = (event) => {
    if (event.key === 'Escape') closeFullscreen();
  };

  const onGalleryClick = (event) => {
    if (!DESKTOP_MQ.matches) return;

    const container = event.target.closest(
      'section[id^="MainProduct-"] .product__modal-opener--image .product__media'
    );
    if (!container) return;

    const img = container.querySelector('img');
    if (!img || img.closest('video, model-viewer, .deferred-media')) return;

    event.preventDefault();
    openFullscreen(img);
  };

  const syncDesktopGallery = () => {
    if (!DESKTOP_MQ.matches) closeFullscreen();
  };

  document.addEventListener('click', onGalleryClick);

  if (DESKTOP_MQ.addEventListener) {
    DESKTOP_MQ.addEventListener('change', syncDesktopGallery);
  } else {
    DESKTOP_MQ.addListener(syncDesktopGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDesktopGallery);
  }

  window.addEventListener('load', syncDesktopGallery);
  document.addEventListener('shopify:section:load', syncDesktopGallery);
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects, variant-radios, .product-form__input')) {
      closeFullscreen();
    }
  });

  window.refreshProductGalleryZoom = syncDesktopGallery;
  window.closeProductDesktopGallery = closeFullscreen;
})();
